(function () {
  const initAnnotatedFeatures = (section) => {
    const allFeatures = section.querySelectorAll(".annotated-features__item");
    const mobileContainers = section.querySelectorAll(
      ".annotated-features-for-mobile"
    );

    const screenWidth =
      document.documentElement.clientWidth || window.innerWidth;

    const allMobileCards = Array.from(mobileContainers).flatMap((container) =>
      Array.from(container.querySelectorAll(".annotated-features__item-inner"))
    );

    const calcNewCoord = (feature) => {
      const card = feature.querySelector(".annotated-features__item-inner");
      const featureRect = feature.getBoundingClientRect();

      if (!card) return;

      card.style.removeProperty("left");
      card.style.removeProperty("right");

      const cardRect = card.getBoundingClientRect();

      if (cardRect.right > screenWidth) {
        let newRight = featureRect.right - cardRect.right;
        if (
          card.classList.contains("annotated-features__item-inner--to-right")
        ) {
          newRight = -1 * (screenWidth - featureRect.right - 20);
        }

        card.style.left = "auto";
        card.style.right = `${newRight}px`;
      } else if (cardRect.left < 0) {
        let newLeft = featureRect.left - cardRect.left;
        if (
          card.classList.contains("annotated-features__item-inner--to-left")
        ) {
          newLeft = -1 * featureRect.left;
        }
        card.style.right = "auto";
        card.style.left = `${newLeft}px`;
      } else if (cardRect.top < 0) {
        let newTop = featureRect.top - cardRect.top;
        if (
          card.classList.contains("annotated-features__item-inner--to-bottom")
        ) {
          newTop = -1 * featureRect.top;
        }
        card.style.bottom = "auto";
        card.style.top = `${newTop}px`;
      }
    };

    const setParentHeight = () => {
      mobileContainers.forEach((mobileContainer) => {
        let activeFeatureItem = mobileContainer.querySelector(
          ".annotated-features__item-inner.active"
        );

        if (activeFeatureItem) {
          let mobileContainerHeight =
            activeFeatureItem.getBoundingClientRect().height + 30;
          mobileContainer.setAttribute(
            "data-height",
            mobileContainerHeight + "px"
          );
          mobileContainer.style.height = `${mobileContainerHeight}px`;
        }
      });
    };

    const onSelectFeature = (feature) => {
      const index = feature.dataset.index;

      // Determine if this feature will now be active (inverse of current state)
      let makeActive = !feature.classList.contains("active");

      if (
        screenWidth <= 990 &&
        feature.classList.contains("mobile-initial-active")
      ) {
        makeActive = false;
      }

      // Remove initial mobile active class
      allFeatures.forEach((f) => f.classList.remove("mobile-initial-active"));

      // Reset all features
      allFeatures.forEach((f) => {
        f.classList.remove("active");
        f.setAttribute("aria-expanded", "false");
        const card = f.querySelector(".annotate-feature-card");
        if (card) card.setAttribute("hidden", "");
      });

      // Activate the feature toggle button
      feature.classList.toggle("active", makeActive);
      feature.setAttribute("aria-expanded", makeActive);

      if (screenWidth >= 990) {
        // Collapse the same feature if clicked again (desktop only)
        const card = feature.querySelector(".annotate-feature-card");
        if (card) {
          if (makeActive) {
            card.removeAttribute("hidden");
          } else {
            card.setAttribute("hidden", "");
          }
        }

        // Recalculate position on desktop only
        calcNewCoord(feature);
      } else {
        if (makeActive) {
          // For mobile: activate correct feature card
          allMobileCards.forEach((card) => {
            card.classList.toggle("active", card.dataset.index == index);
            if (card.dataset.index == index) {
              // setParentHeight();
              let cardContainer = card.parentElement;
              let cardHeight = cardContainer.dataset.height;
              cardContainer.style.height = cardHeight;
            }
          });
        } else {
          // For mobile: activate correct feature card
          allMobileCards.forEach((card) => {
            card.classList.toggle("active", false);
          });

          mobileContainers.forEach((mobileContainer) => {
            mobileContainer.style.height = "0px";
          });
        }
      }
    };

    allFeatures.forEach((feature) => {
      feature.setAttribute("tabindex", "0");

      calcNewCoord(feature);

      feature.addEventListener("click", (event) => {
        onSelectFeature(feature);
      });

      feature.addEventListener("mouseover", () => {
        if (feature.classList.contains("active")) {
          return;
        }

        if (screenWidth >= 990) {
          calcNewCoord(feature);
        }
      });

      feature.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.keyCode === 13) {
          event.preventDefault();
          onSelectFeature(feature);
        }
      });
    });

    document.addEventListener("click", (event) => {
      if (screenWidth < 990) return;

      const parentClicked = event.target.closest(".annotated-features__item");
      allFeatures.forEach((feature) => {
        if (parentClicked != feature) {
          feature.classList.remove("active");
        }
      });
    });

    if (screenWidth <= 990) {
      setParentHeight();
    }
  };

  const annotatedFeaturesSection = document.currentScript.parentElement;

  const tabContents =
    annotatedFeaturesSection.querySelectorAll(".chw-tab_content");

  tabContents.forEach((tabContent) => {
    initAnnotatedFeatures(tabContent);
  });
})();
